export class ClientSettings {
    public highlightColor: string;
    public currency: string;
    public title: string;
    public webpageTitle: string;
    public appLoginMsg: string;
    public showDeclarationDates: boolean;
}  